import { render, staticRenderFns } from "./ShareDocumentModal.vue?vue&type=template&id=5022353b&scoped=true"
import script from "./ShareDocumentModal.vue?vue&type=script&lang=js"
export * from "./ShareDocumentModal.vue?vue&type=script&lang=js"
import style0 from "./ShareDocumentModal.vue?vue&type=style&index=0&id=5022353b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5022353b",
  null
  
)

export default component.exports